var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScienceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1200 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,184.7,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.4,78.2C182.6,73.7 174.6,71.4 166.5,71.5C136.2,71.5 114.9,93.2 114.9,124.9C114.9,156.6 141.5,175.9 169.3,175.9C197.1,175.9 199.6,171.7 212.5,163.6L212.5,29L189.4,29L189.4,78.2ZM161.4,156.8C153,156.8 143.8,153.3 139.1,148L139.1,95.8C145.2,92.2 152.2,90.5 159.2,90.7C175.2,90.7 189.3,103.4 189.3,122.6C189.3,141.8 178.4,156.8 161.4,156.8Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424,95.9L423.4,95.9C419.2,96.1 415.9,99.7 416.1,103.9L416.1,104.2C416.1,108.6 419.8,112.1 424.2,112C428.6,112 432.1,108.3 432,103.9L432,103.1C431.8,98.9 428.2,95.7 424,95.9Z",
    style: {
      fillRule: "nonzero"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 417.8,
    y: 121,
    width: 12.4,
    height: 53.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M457.7,129.3L457.7,121L445.3,121L445.3,174.1L457.7,174.1L457.7,144.6C457.7,138 461.2,131.3 467.2,131.3C473.2,131.3 472.2,132.2 474.2,133.8L478.7,122.2C475.9,120.4 472.6,119.5 469.2,119.6C463,119.6 458.8,126.8 457.6,129.3L457.7,129.3Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.1,119.6C493.5,119.6 482.4,131.6 482.4,148C482.4,164.4 494.2,175.7 511.7,175.7C519.7,175.9 527.6,173.4 534.1,168.7L530.2,159.9C525.5,163.6 519.7,165.5 513.8,165.5C502.1,165.5 495.9,159.2 495.2,152.4L536,152.4L536,147.3C536,132.6 527.4,119.8 510.2,119.8L510.1,119.6ZM495.3,142.3C496,134.8 502.4,129.1 509.9,129.4L510.4,129.4C517.4,129.4 523.1,135.3 523,142.3L495.3,142.3Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.8,165.5L573,165.5C563.8,164.9 556.8,157 557.4,147.8C557.4,136.3 565.3,130 573.8,130C578.6,130.1 583.1,131.9 586.6,135.1L591.3,125.8C586.1,121.8 579.8,119.6 573.2,119.6C557.9,119.4 545.2,131.5 544.8,146.8C544.3,162.3 556.5,175.2 572,175.7C579.7,176.1 587.2,173.3 592.9,168L588.9,159.4C584.9,163.5 579.4,165.7 573.8,165.5Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.3,119.6C651.8,119.3 639,131.5 638.6,147C638.3,162.5 650.5,175.3 666,175.7L666.6,175.7C682.1,175.7 694.6,163.2 694.6,147.7C694.6,132.2 682.4,119.9 667.2,119.6L667.3,119.6ZM681.6,147.7C681.6,158.5 675.4,165.4 665.9,165.4L665.7,165.4C656.6,164.9 649.7,157.1 650.2,148C650.2,137.1 657,129.9 666.2,129.9C675.4,129.9 681.5,137.1 681.5,147.7L681.6,147.7Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.8,129.2L718.8,121L706.4,121L706.4,174.1L718.8,174.1L718.8,144.6C718.8,138 722.3,131.3 728.3,131.3C734.3,131.3 733.3,132.2 735.3,133.8L739.8,122.2C737,120.4 733.7,119.5 730.3,119.6C724.1,119.6 719.9,126.8 718.7,129.3L718.8,129.2Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.3,121L770.6,154.6L755,121L741.2,121L763.6,167.3L744.9,201L758.9,201L800.6,121L786.3,121Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.9,121.4C387.1,118.9 382.7,117.6 378.2,117.7C361.4,117.7 349.6,129.7 349.6,147.3C349.6,164.9 364.4,175.6 379.7,175.6C395,175.6 396.5,173.3 403.7,168.8L403.7,94.1L390.9,94.1L390.9,121.4ZM375.4,165C370.7,165 365.6,163.1 363,160.1L363,131.1C366.4,129.1 370.3,128.2 374.2,128.3C383.1,128.3 390.9,135.4 390.9,146C390.9,156.6 384.8,165 375.4,165Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.1,165.1C620.3,164.1 614.9,158.4 614.3,152.1L614.3,136.1L634.1,136.1L634.1,125.9L614.3,125.9L614.3,96.1L601.4,96.1L601.4,148.5C601.8,165 613.5,175.7 630.9,175.7C648.3,175.7 636.1,175.4 638.7,174.9C635,172.4 632.1,169.1 630.1,165.1Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.4,
    y: 27.7,
    width: 7.1,
    height: 146
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7,147.5C41.6,153.2 52.9,159.4 63,159.4C72,159.4 77.6,154.5 77.6,148.1C77.6,130 34.1,127.8 34.1,100.5C34.1,85.7 47,72.2 68.4,72.2C84.4,72.2 96.3,79.6 100.6,83.3L92,99.3C90.4,97.5 81.5,89.7 71.1,89.7C63.7,89.7 58.2,93.8 58.2,99.7C58.2,116.1 100.9,116.9 100.9,146.9C100.9,164.5 86.5,176.8 64,176.8C47.2,176.8 34.3,170 26.9,163.9L35.7,147.5Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.7,67.2C356.5,69.9 361.9,72.9 366.7,72.9C371,72.9 373.7,70.6 373.7,67.5C373.7,58.9 353,57.8 353,44.8C353,37.7 359.1,31.3 369.3,31.3C376.9,31.3 382.6,34.8 384.6,36.6L380.5,44.2C379.8,43.4 375.5,39.6 370.6,39.6C367.1,39.6 364.5,41.6 364.5,44.3C364.5,52.1 384.8,52.5 384.8,66.8C384.8,75.2 377.9,81 367.2,81C359.2,81 353.1,77.7 349.6,74.9L353.7,67.2Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.4,74.3C432.3,76.4 426.5,81.1 415.9,81.1C404.8,81.1 391.7,71.8 391.7,56.3C391.7,42.1 403.4,31.5 417.1,31.5C425.1,31.5 431.5,35.4 433.1,37L428.9,45.3C427.6,44.1 423.3,40.7 417.6,40.7C410.1,40.7 403.1,46.3 403.1,56.4C403.1,65.6 409.5,72.1 417.6,72.1C424.9,72.1 429.4,68.5 431,66.7L434.4,74.3Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.5,17.7C441.5,13.5 444.5,10.6 448.5,10.6C452.8,10.6 455.6,13.6 455.6,17.7C455.6,21.9 452.6,24.8 448.5,24.8C444.5,24.7 441.5,21.8 441.5,17.7ZM443,79.7L443,32.8L454,32.8L454,79.7L443,79.7Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5,74.9C507,77.1 499.7,81.1 489.7,81.1C474.2,81.1 463.8,71.4 463.8,56.6C463.8,42.1 473.6,31.5 488.3,31.5C503.5,31.5 511.1,42.8 511.1,55.8L511.1,60.4L475.1,60.4C475.8,66.4 481.2,72 491.5,72C498.7,72 503.5,69 506,67.1L509.5,74.9ZM499.8,51.6C499.5,45.5 495.4,40.2 488.2,40.2C481.8,40.2 476.1,44.3 475.3,51.6L499.8,51.6Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.4,79.7L551.4,54.2C551.4,46 549.9,41.2 542.3,41.2C537.7,41.2 533,44.6 531.5,46.6L531.5,79.8L520.5,79.8L520.5,32.8L531.5,32.8L531.5,37.6C533.9,35.4 539.3,31.5 546.5,31.5C556.7,31.5 562.3,36.6 562.3,48.4L562.3,79.7L551.4,79.7Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.2,74.3C612.1,76.4 606.3,81.1 595.7,81.1C584.6,81.1 571.5,71.8 571.5,56.3C571.5,42.1 583.2,31.5 596.9,31.5C604.9,31.5 611.3,35.4 612.9,37L608.7,45.3C607.4,44.1 603.1,40.7 597.4,40.7C589.9,40.7 582.9,46.3 582.9,56.4C582.9,65.6 589.3,72.1 597.4,72.1C604.7,72.1 609.2,68.5 610.8,66.7L614.2,74.3Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.1,74.9C661.6,77.1 654.3,81.1 644.3,81.1C628.8,81.1 618.4,71.4 618.4,56.6C618.4,42.1 628.2,31.5 642.9,31.5C658.1,31.5 665.7,42.8 665.7,55.8L665.7,60.4L629.7,60.4C630.4,66.4 635.8,72 646.1,72C653.3,72 658.1,69 660.6,67.1L664.1,74.9ZM654.3,51.6C654,45.5 649.9,40.2 642.7,40.2C636.3,40.2 630.6,44.3 629.8,51.6L654.3,51.6Z",
    style: {
      fill: "rgb(66,193,199)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,184.7,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.1,257.5C102.3,258.9 104.5,260.7 108.1,260.7C111.1,260.7 113.4,259.1 113.4,255.9C113.4,250.3 101.3,250.8 101.3,243.8C101.3,240.1 104.3,237.1 109,237.1C112.2,237.1 115.1,238.7 116.3,240L114.8,242.5C114.2,241.8 111.9,239.9 109.1,239.9C105.9,239.9 104.7,241.9 104.7,243.5C104.7,248.4 116.8,247.5 116.8,255.8C116.8,260.5 113.1,263.5 108,263.5C103.7,263.5 100.7,261.5 99.2,259.8L101.1,257.5Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.9,276.1L122.9,240.4C126,238.2 129.8,237.1 133.4,237.1C140.4,237.1 147,241.5 147,250.4C147,257.3 142.5,263.5 134.8,263.5C131.5,263.5 128.1,261.9 126.3,260.1L126.3,276.1L122.9,276.1ZM126.3,256.4C127.9,258.7 131.2,260.6 134.7,260.6C139.4,260.6 143.4,256.9 143.4,250.6C143.4,244.7 139.6,240.4 133.1,240.4C130.6,240.4 127.6,241.5 126.4,242.5L126.4,256.4L126.3,256.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.9,259.4C173.2,261.7 169.4,263.6 164.5,263.6C157.1,263.6 151.6,258.3 151.6,250.5C151.6,242.7 156.6,237.2 164.3,237.2C172,237.2 175.6,243.3 175.6,249.7L175.6,250.6L155.1,250.6C155.1,256.8 159.2,260.6 165.2,260.6C169.5,260.6 172.1,258.6 173.3,257.3L174.9,259.4ZM172.1,247.9C171.7,243.7 169.1,240.2 164.2,240.2C159.8,240.2 155.9,242.9 155.3,247.9L172.1,247.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.1,259.3C201.1,261.9 197.5,263.5 193,263.5C185.7,263.5 180.1,257.9 180.1,250.4C180.1,242.8 185.7,237.1 193.4,237.1C198.1,237.1 201.5,239.7 202.2,240.5L200.4,242.8C199.8,242.2 197.2,240.1 193.4,240.1C188.7,240.1 183.8,243.4 183.8,250.3C183.8,256.6 188.3,260.4 193.6,260.4C197.8,260.4 200,258.8 201.6,257.2L203.1,259.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.6,232.9C209.1,232.9 207.9,231.8 207.9,230.3C207.9,228.7 209.1,227.6 210.6,227.6C212.2,227.6 213.3,228.7 213.3,230.3C213.2,231.7 212.1,232.9 210.6,232.9ZM208.8,262.9L208.8,237.9L212.2,237.9L212.2,262.9L208.8,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.6,260C237.3,262.2 233.5,263.5 228.7,263.5C221.4,263.5 218,259.2 218,254.5C218,248.9 224,246.3 228.3,246.3C231,246.3 234.2,247.1 236.2,249.1L236.2,245.6C236.2,242.5 233.8,240.1 229.3,240.1C226,240.1 223.1,241.2 222.3,241.6L221,239C222.7,238.2 225.5,237.1 229.3,237.1C237.4,237.1 239.5,240.9 239.5,246.5L239.5,260L239.6,260ZM236.2,252.1C234.8,250.7 232.3,249.1 228.7,249.1C225.5,249.1 221.6,250.8 221.6,254.5C221.6,258.6 224.9,260.7 228.9,260.7C232.2,260.7 234.6,259.8 236.2,258.6L236.2,252.1Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.2,
    y: 220.3,
    width: 3.4,
    height: 42.6,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.7,232.9C259.2,232.9 258,231.8 258,230.3C258,228.7 259.2,227.6 260.7,227.6C262.3,227.6 263.4,228.7 263.4,230.3C263.4,231.7 262.2,232.9 260.7,232.9ZM259,262.9L259,237.9L262.4,237.9L262.4,262.9L259,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.6,257.5C270.8,258.9 273,260.7 276.6,260.7C279.6,260.7 281.9,259.1 281.9,255.9C281.9,250.3 269.8,250.8 269.8,243.8C269.8,240.1 272.8,237.1 277.5,237.1C280.7,237.1 283.6,238.7 284.8,240L283.3,242.5C282.7,241.8 280.4,239.9 277.6,239.9C274.4,239.9 273.2,241.9 273.2,243.5C273.2,248.4 285.3,247.5 285.3,255.8C285.3,260.5 281.6,263.5 276.5,263.5C272.2,263.5 269.2,261.5 267.7,259.8L269.6,257.5Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.4,262.9L293.4,240.9L288.8,240.9L288.8,237.9L293.4,237.9L293.4,229L296.8,229L296.8,237.9L302.9,237.9L302.9,240.9L296.8,240.9L296.8,262.9L293.4,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.8,220.2L323.3,220.2L323.3,240.6C324.7,239.2 328.3,237.1 332,237.1C340.3,237.1 344,243.3 344,250.2C344,259 337.3,263.5 330.3,263.5C326.7,263.5 322.9,262.5 319.8,260.1L319.8,220.2ZM323.4,258.5C324.6,259.5 327.6,260.6 330.4,260.6C335.9,260.6 340.4,257 340.4,250.2C340.4,244.7 337.4,240.2 331.6,240.2C328.4,240.2 324.7,242.4 323.3,244.2L323.3,258.5L323.4,258.5Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.3,232.9C350.8,232.9 349.6,231.8 349.6,230.3C349.6,228.7 350.8,227.6 352.3,227.6C353.9,227.6 355,228.7 355,230.3C354.9,231.7 353.8,232.9 352.3,232.9ZM350.5,262.9L350.5,237.9L353.9,237.9L353.9,262.9L350.5,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.7,263.6C366.2,263.6 360.3,257.9 360.3,250.4C360.3,242.9 366.2,237.2 373.7,237.2C381.2,237.2 387,243.1 387,250.4C387,257.7 381.2,263.6 373.7,263.6ZM383.3,250.4C383.3,244.5 378.8,240.2 373.6,240.2C367.8,240.2 363.8,244.5 363.8,250.5C363.8,256.3 368.5,260.5 373.5,260.5C379.4,260.5 383.3,256.5 383.3,250.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.4,
    y: 220.3,
    width: 3.4,
    height: 42.6,
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.7,263.6C409.2,263.6 403.3,257.9 403.3,250.4C403.3,242.9 409.2,237.2 416.7,237.2C424.2,237.2 430,243.1 430,250.4C430,257.7 424.2,263.6 416.7,263.6ZM426.3,250.4C426.3,244.5 421.8,240.2 416.6,240.2C410.8,240.2 406.8,244.5 406.8,250.5C406.8,256.3 411.5,260.5 416.5,260.5C422.4,260.5 426.3,256.5 426.3,250.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.1,259.5C453.1,261.9 449.6,263.6 446.6,263.6C440.6,263.6 434.5,258.8 434.5,250.5C434.5,241.8 441.1,237.2 448.2,237.2C453.3,237.2 456.8,239 458.5,240.4L458.5,264.3C458.5,273.8 452.5,276.6 446.9,276.6C443.1,276.6 439.6,275.6 436.8,273.7L438.4,271C440.7,272.6 444,273.5 447.1,273.5C450.7,273.5 455.3,272.1 455.3,264.5L455.3,259.5L455.1,259.5ZM455.1,242.1C454.2,241.6 451.8,240.2 448.2,240.2C443.1,240.2 438.2,243.5 438.2,250.4C438.2,254.9 440.9,260.4 447.4,260.4C450.3,260.4 453.7,258.4 455.1,255.8L455.1,242.1Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.9,276.3L473,260.4L462.7,237.8L466.5,237.8L474.9,257L484.1,237.8L487.9,237.8L468.6,276.3L464.9,276.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.6,268.4L490.4,258.2L494.3,258.2L489.4,268.4L486.6,268.4Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.7,259.3C533.7,261.9 530.1,263.5 525.6,263.5C518.3,263.5 512.7,257.9 512.7,250.4C512.7,242.8 518.3,237.1 526,237.1C530.7,237.1 534.1,239.7 534.8,240.5L533,242.8C532.4,242.2 529.8,240.1 526,240.1C521.3,240.1 516.4,243.4 516.4,250.3C516.4,256.6 520.9,260.4 526.2,260.4C530.4,260.4 532.6,258.8 534.2,257.2L535.7,259.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.7,262.9L558.7,248.1C558.7,242.7 556.9,240.4 552,240.4C548.5,240.4 545.7,242.5 544.6,243.7L544.6,262.8L541.2,262.8L541.2,220.2L544.6,220.2L544.6,240.5C546,239.3 548.8,237.2 553,237.2C558.8,237.2 562.1,240.1 562.1,246.5L562.1,262.9L558.7,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.4,259.4C589.7,261.7 585.9,263.6 581,263.6C573.6,263.6 568.1,258.3 568.1,250.5C568.1,242.7 573.1,237.2 580.8,237.2C588.5,237.2 592.1,243.3 592.1,249.7L592.1,250.6L571.6,250.6C571.6,256.8 575.7,260.6 581.7,260.6C586,260.6 588.6,258.6 589.8,257.3L591.4,259.4ZM588.6,247.9C588.2,243.7 585.6,240.2 580.7,240.2C576.3,240.2 572.4,242.9 571.8,247.9L588.6,247.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.6,263L630.6,246.6C630.6,242.1 628.6,240.5 625,240.5C621.8,240.5 618.9,242.6 617.7,243.9C617.8,244.7 617.9,245.4 617.9,246.2L617.9,263L614.5,263L614.5,246.6C614.5,242.1 612.4,240.5 608.8,240.5C605.7,240.5 602.9,242.6 601.8,243.8L601.8,263L598.4,263L598.4,238L601.8,238L601.8,240.7C603.2,239.5 606.2,237.4 610.1,237.4C613.7,237.4 615.8,239.3 616.9,241.2C618.8,239.6 622.2,237.4 626.2,237.4C631,237.4 634.2,240.2 634.2,246.4L634.2,263L630.6,263Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.6,232.9C642.1,232.9 640.9,231.8 640.9,230.3C640.9,228.7 642.1,227.6 643.6,227.6C645.2,227.6 646.3,228.7 646.3,230.3C646.2,231.7 645.1,232.9 643.6,232.9ZM641.8,262.9L641.8,237.9L645.2,237.9L645.2,262.9L641.8,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.5,257.5C653.7,258.9 655.9,260.7 659.5,260.7C662.5,260.7 664.8,259.1 664.8,255.9C664.8,250.3 652.7,250.8 652.7,243.8C652.7,240.1 655.7,237.1 660.4,237.1C663.6,237.1 666.5,238.7 667.7,240L666.2,242.5C665.6,241.8 663.3,239.9 660.5,239.9C657.3,239.9 656.1,241.9 656.1,243.5C656.1,248.4 668.2,247.5 668.2,255.8C668.2,260.5 664.5,263.5 659.4,263.5C655.1,263.5 652.1,261.5 650.6,259.8L652.5,257.5Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676.2,262.9L676.2,240.9L671.6,240.9L671.6,237.9L676.2,237.9L676.2,229L679.6,229L679.6,237.9L685.7,237.9L685.7,240.9L679.6,240.9L679.6,262.9L676.2,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690.4,262.9L690.4,237.9L693.8,237.9L693.8,241.5C694.1,240.4 696.3,237.2 699.2,237.2C701.1,237.2 702.9,238 703.4,238.3L701.8,241.6C701.3,241.2 700.2,240.6 698.9,240.6C696,240.6 694.1,243.8 693.9,245.9L693.9,262.9L690.4,262.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-220,10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.6,276.3L714.7,260.4L704.4,237.8L708.2,237.8L716.6,257L725.8,237.8L729.6,237.8L710.3,276.3L706.6,276.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.7,322.4C232.4,324.6 228.6,325.9 223.8,325.9C216.5,325.9 213.1,321.6 213.1,316.9C213.1,311.3 219.1,308.7 223.4,308.7C226.1,308.7 229.3,309.5 231.3,311.5L231.3,308C231.3,304.9 228.9,302.5 224.4,302.5C221.1,302.5 218.2,303.6 217.4,304L216.1,301.4C217.8,300.6 220.6,299.5 224.4,299.5C232.5,299.5 234.6,303.3 234.6,308.9L234.6,322.4L234.7,322.4ZM231.3,314.5C229.9,313.1 227.4,311.5 223.8,311.5C220.6,311.5 216.7,313.2 216.7,316.9C216.7,321 220,323.1 224,323.1C227.3,323.1 229.7,322.2 231.3,321L231.3,314.5Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.5,325.3L259.5,310.5C259.5,305.1 257.7,302.8 252.8,302.8C249.3,302.8 246.5,304.9 245.4,306.1L245.4,325.2L242,325.2L242,300.2L245.4,300.2L245.4,302.9C246.8,301.7 249.6,299.6 253.8,299.6C259.6,299.6 262.9,302.5 262.9,308.9L262.9,325.3L259.5,325.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.5,282.6L293,282.6L293,322.5C289.9,324.8 286.2,325.9 282.5,325.9C275.5,325.9 268.9,321.8 268.9,313.1C268.9,304.9 274.2,299.5 281.7,299.5C284.6,299.5 287.6,300.5 289.5,302.2L289.5,282.6ZM289.6,306.2C288.3,304.1 285.1,302.6 281.9,302.6C276.3,302.6 272.6,306.6 272.6,313.2C272.6,319.6 277.3,323 282.6,323C284.7,323 287.3,322.5 289.6,320.9L289.6,306.2Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.1,338.5L313.1,302.8C316.2,300.6 320,299.5 323.6,299.5C330.6,299.5 337.2,303.9 337.2,312.8C337.2,319.7 332.7,325.9 325,325.9C321.7,325.9 318.3,324.3 316.5,322.5L316.5,338.5L313.1,338.5ZM316.5,318.8C318.1,321.1 321.4,323 324.9,323C329.6,323 333.6,319.3 333.6,313C333.6,307.1 329.8,302.8 323.3,302.8C320.8,302.8 317.8,303.9 316.6,304.9L316.6,318.8L316.5,318.8Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.9,325.3L360.9,310.5C360.9,305.1 359.1,302.8 354.2,302.8C350.7,302.8 347.9,304.9 346.8,306.1L346.8,325.2L343.4,325.2L343.4,282.6L346.8,282.6L346.8,302.9C348.2,301.7 351,299.6 355.2,299.6C361,299.6 364.3,302.5 364.3,308.9L364.3,325.3L360.9,325.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.3,338.7L378.4,322.8L368,300.3L371.8,300.3L380.2,319.5L389.4,300.3L393.2,300.3L373.9,338.8L370.3,338.8L370.3,338.7Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.4,319.9C397.6,321.3 399.8,323.1 403.4,323.1C406.4,323.1 408.7,321.5 408.7,318.3C408.7,312.7 396.6,313.2 396.6,306.2C396.6,302.5 399.6,299.5 404.3,299.5C407.5,299.5 410.4,301.1 411.6,302.4L410.1,304.9C409.5,304.2 407.2,302.3 404.4,302.3C401.2,302.3 400,304.3 400,305.9C400,310.8 412.1,309.9 412.1,318.2C412.1,322.9 408.4,325.9 403.3,325.9C399,325.9 396,323.9 394.5,322.2L396.4,319.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.3,295.3C418.8,295.3 417.6,294.2 417.6,292.7C417.6,291.1 418.8,290 420.3,290C421.9,290 423,291.1 423,292.7C422.9,294.1 421.8,295.3 420.3,295.3ZM418.5,325.3L418.5,300.3L421.9,300.3L421.9,325.3L418.5,325.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.4,321.7C449.4,324.3 445.8,325.9 441.3,325.9C434,325.9 428.4,320.3 428.4,312.8C428.4,305.2 434,299.5 441.7,299.5C446.4,299.5 449.8,302.1 450.5,302.9L448.7,305.2C448.1,304.6 445.5,302.5 441.7,302.5C437,302.5 432.1,305.8 432.1,312.7C432.1,319 436.6,322.8 441.9,322.8C446.1,322.8 448.3,321.2 449.9,319.6L451.4,321.7Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.1,319.9C457.3,321.3 459.5,323.1 463.1,323.1C466.1,323.1 468.4,321.5 468.4,318.3C468.4,312.7 456.3,313.2 456.3,306.2C456.3,302.5 459.3,299.5 464,299.5C467.2,299.5 470.1,301.1 471.3,302.4L469.8,304.9C469.2,304.2 466.9,302.3 464.1,302.3C460.9,302.3 459.7,304.3 459.7,305.9C459.7,310.8 471.8,309.9 471.8,318.2C471.8,322.9 468.1,325.9 463,325.9C458.7,325.9 455.7,323.9 454.2,322.2L456.1,319.9Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.3,325.3L492.3,303.3L487.7,303.3L487.7,300.3L492.3,300.3L492.3,291.4L495.7,291.4L495.7,300.3L501.8,300.3L501.8,303.3L495.7,303.3L495.7,325.3L492.3,325.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.8,300.3L527.3,300.3L527.3,322.5C524.8,324.8 521.4,326 516.8,326C510.6,326 506.2,322.8 506.2,316.4L506.2,300.3L509.6,300.3L509.6,315.6C509.6,320.7 512.6,323 516.9,323C520.4,323 522.6,321.9 523.8,321L523.8,300.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.9,325.3L536.9,303.3L532.3,303.3L532.3,300.3L536.9,300.3L536.9,291.4L540.3,291.4L540.3,300.3L546.4,300.3L546.4,303.3L540.3,303.3L540.3,325.3L536.9,325.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.4,326C554.9,326 549,320.3 549,312.8C549,305.3 554.9,299.6 562.4,299.6C569.9,299.6 575.7,305.5 575.7,312.8C575.7,320.1 569.9,326 562.4,326ZM572,312.8C572,306.9 567.5,302.6 562.3,302.6C556.5,302.6 552.5,306.9 552.5,312.9C552.5,318.7 557.2,322.9 562.2,322.9C568.1,322.9 572,318.9 572,312.8Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.8,325.3L581.8,300.3L585.2,300.3L585.2,303.9C585.5,302.8 587.7,299.6 590.6,299.6C592.5,299.6 594.3,300.4 594.8,300.7L593.2,304C592.7,303.6 591.6,303 590.3,303C587.4,303 585.5,306.2 585.3,308.3L585.3,325.3L581.8,325.3Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,313.02,-50.2041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.2,319.9C599.4,321.3 601.6,323.1 605.2,323.1C608.2,323.1 610.5,321.5 610.5,318.3C610.5,312.7 598.4,313.2 598.4,306.2C598.4,302.5 601.4,299.5 606.1,299.5C609.3,299.5 612.2,301.1 613.4,302.4L611.9,304.9C611.3,304.2 609,302.3 606.2,302.3C603,302.3 601.8,304.3 601.8,305.9C601.8,310.8 613.9,309.9 613.9,318.2C613.9,322.9 610.2,325.9 605.1,325.9C600.8,325.9 597.8,323.9 596.3,322.2L598.2,319.9Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceLogo);
export default __webpack_public_path__ + "static/media/science-logo.750397d1dc6a8518a45cb8d65b4b26fa.svg";
export { ForwardRef as ReactComponent };